import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { LettereDiffidaDatiGeneraliForm } from '../../../form/lettera-diffida-dati-generali-form';
import { SezioneLettereDiffidaResponse } from '../../../models/dto/sezione-lettere-diffida-response';
import { LetteraDiffida } from '../../../models/lettera-diffida';

import { SezioneLettereDiffidaFull } from '../../../models/sezioni/sezione-lettere-diffida-full';

@Component({
    selector: 'div [lettere-diffida-dati-generali-update-form]',
  templateUrl: '../../../form/lettera-diffida-dati-generali-form.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class LettereDiffidaDatiGeneraliComponent extends LettereDiffidaDatiGeneraliForm implements OnInit {

  @Output() onReturn: EventEmitter<SezioneLettereDiffidaFull> = new EventEmitter<SezioneLettereDiffidaFull>();

  idSezione: string;
  letteraDiffida: LetteraDiffida;
  updateUrl: string;
  urlReadSezioneControparti: string;

  constructor(@Inject(HelpersService) helpers: HelpersService, @Inject(OperationsService) operations: OperationsService, @Inject(FormBuilder) campiForm: FormBuilder) {
    super(helpers, operations, campiForm);
  }

  ngOnInit() {
    this.setTitle('Modifica dati');
    this.isInserimento(false);
  }

  getRequest(request: LetteraDiffida) {
    this.operations.setLetteraDiffidaInSezLettereDiffida(this.updateUrl, this.idSezione, request).subscribe(response => this.returnSetSezLettereDiffida(response));
  }

  returnSetSezLettereDiffida(response: SezioneLettereDiffidaResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(updateUrl: string, letteraDiffida: LetteraDiffida, idSezione: string, urlReadSezioneControparti: string, idSezioneControparti: string) {
    this.letteraDiffida = letteraDiffida;
    this.idSezione = idSezione;
    this.updateUrl = updateUrl;
    this.urlReadSezioneControparti = urlReadSezioneControparti;
    if (idSezioneControparti) {
      this.readSezioneControparti(idSezioneControparti);
    }
    this.populateSelect(urlReadSezioneControparti, idSezioneControparti);
    this.createForm();
  }

  getUrlReadSezioneControparti(): string {
    return this.urlReadSezioneControparti;
  }

  getLetteraDiffida(): LetteraDiffida {
    return this.letteraDiffida;
  }
}
